import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { insurers, processSteps } from '../data/process';
export function ProcessSection() {
  return <section id="process" aria-labelledby="process-heading" className="bg-surface py-20 lg:py-28" data-id="element-195" data-mp="z33csxf5767v">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-196" data-mp="u4085e32r20f">
        <div className="grid gap-6 lg:grid-cols-2 lg:items-end lg:gap-16" data-id="element-197" data-mp="p3w10eo23jmv">
          <div data-id="element-198" data-mp="1mqbez6h9xz5o">
            <p className="mb-3 text-sm font-semibold text-accent" data-id="element-199" data-mp="1mqupi24lhl9o">How it works</p>
            <h2 id="process-heading" className="font-display text-3xl font-bold tracking-tight sm:text-4xl" data-id="element-200" data-mp="1hrrr30j4edao">
              From estimate to keys in five steps.
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-muted" data-id="element-201" data-mp="181yim8e9yean">
            We text you updates and photos at every stage, so you're never wondering where your car is or what's
            happening to it.
          </p>
        </div>

        <ol className="mt-16 grid gap-10 md:grid-cols-5 md:gap-6" data-id="element-202" data-mp="20pb56ikfqm3y">
          {processSteps.map((step, index) => <li key={step.title} data-id="element-203" data-mp="262wfr38ct7zu" data-mpi={index}>
              <div className="flex items-center" data-id="element-204" data-mp="264qs3t5k7rsb">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 border-ink font-display text-sm font-bold" data-id="element-205" data-mp="2b060i5kssvhc">
                  {index + 1}
                </span>
                {index < processSteps.length - 1 && <span aria-hidden="true" className="ml-4 hidden h-px flex-1 bg-line md:block" data-id="element-206" data-mp="1nc4x1b2h858s" />}
              </div>
              <h3 className="mt-5 font-display text-lg font-bold tracking-tight" data-id="element-207" data-mp="1rejdxpml4uxf">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-208" data-mp="1deqsa8px14wb">{step.description}</p>
            </li>)}
        </ol>

        <div className="mt-20 grid gap-10 rounded-xl bg-ink p-8 text-white sm:p-10 lg:grid-cols-12 lg:gap-16 lg:p-14" data-id="element-209" data-mp="1id206dwnh5bw">
          <div className="lg:col-span-7" data-id="element-210" data-mp="37px36s38toy8">
            <h3 className="font-display text-2xl font-bold tracking-tight sm:text-3xl" data-id="element-211" data-mp="3cprwf2ahqqmg">Your car, your choice of shop.</h3>
            <p className="mt-4 max-w-xl leading-relaxed text-white/75" data-id="element-212" data-mp="3bb8q3q9d5fnl">
              Montana law gives you the right to choose where your vehicle is repaired — your insurer can't require a
              specific shop. We work with every major carrier and handle the claim, the adjuster, and any supplements
              for you.
            </p>
            <a href="#estimate" className="group mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-surface px-5 py-3 text-sm font-semibold text-accent transition-colors duration-150 hover:bg-paper focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-ink" data-id="element-213" data-mp="3tzvsu242hsy0">
              Start an insurance estimate
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-214" data-mp="gmak0s56itc8" />
            </a>
          </div>
          <div className="lg:col-span-5" data-id="element-215" data-mp="bthfa49pnl05">
            <p className="text-sm font-medium text-white/60" data-id="element-216" data-mp="bsplmyzobxci">We work directly with</p>
            <ul className="mt-4 grid grid-cols-2 border-t border-white/15" data-id="element-217" data-mp="k59f8lfqovbc">
              {insurers.map(insurer => <li key={insurer} className="border-b border-white/15 py-3 font-medium text-white/90" data-id="element-218" data-mp="t3uti4e6ho6b">
                  {insurer}
                </li>)}
            </ul>
            <p className="mt-4 text-sm text-white/60" data-id="element-219" data-mp="y0v3gqe5fb2p">…and every other licensed carrier.</p>
          </div>
        </div>
      </div>
    </section>;
}